import * as Logger from '../libs/wa-logger';
import * as Guards from '../libs/guards'
/**
 * Attach a click handler to each item-summary and when clicked
 * find the href of the descendant nnode that is an anchor and link to that
 */
// const initialize = function init() {
export function initialize() {
    const elements = document.querySelectorAll(".item-summary")
	elements.forEach((el, index) => {
		const eldiv = Guards.isHTMLDiv(el)

		Logger.writeln(["post-summary ", el, index])
		eldiv.addEventListener("click", (event) => {
			const a = eldiv.querySelectorAll("a.item-link")
			if(a.length !== 1) {
				throw new Error("post-summary did not find exactly one anchor")
			}
			const ael = Guards.isHTMLanchor(a[0])
			const h = ael.href
			Logger.writeln("in click handler")
			window.location.href = h
		})
	})
}
